import { LearningItemStatus } from '../../models/BaseModels'
import * as api from '../api'
import useInvalidate from '../useInvalidate'
import useApiMutation from './useApiMutation'

type CreateOnDemandCourseArgs = {
  status: LearningItemStatus
  title: string
  description: string
  image: string | null | undefined
  categoryUuids: string[]
  providerUuid: string | null | undefined
  isGlobalProvider?: boolean
  clientUuid: string | null | undefined
  createCertificate: boolean
  certificateValidUntil: Date | null | undefined
  durationInMin: number
  contentLocales: string[]
  externalId: string
  isFavorite: boolean
}

export default function useCreateOnDemandCourse() {
  const invalidate = useInvalidate()

  return useApiMutation({
    mutationFn: async (data: CreateOnDemandCourseArgs) => {
      const result = api.post('on-demand-course', {
        status: data.status,
        title: data.title,
        description: data.description,
        image: data.image || undefined,
        categories: data.categoryUuids,
        provider_uuid: data.providerUuid,
        is_global_provider: data.isGlobalProvider,
        client_uuid: data.clientUuid,
        create_certificate: data.createCertificate,
        certificate_valid_until: data.certificateValidUntil,
        duration_in_min: data.durationInMin,
        content_locales: data.contentLocales,
        external_id: data.externalId,
      })

      await invalidate.courses()

      return result
    },
  })
}
